import { render } from "./StreamDonationOverviewNewDonation.vue?vue&type=template&id=d5535ef2"
import script from "./StreamDonationOverviewNewDonation.vue?vue&type=script&lang=js"
export * from "./StreamDonationOverviewNewDonation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__